import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { useGlobalContext } from "../GlobalContext";

const useTier = () => {
  const { baseurl, token, setIsUnauthorised, AdminId } = useGlobalContext();

  const [Loading, setLoading] = useState(true);
  const [benefitsLoading, setBenefitsLoading] = useState(false);

  // ======= TIER LIST API =======
  const FetchTierCall = async (driverId = "", setTiers, setFilteredTiers) => {
    setLoading(true);
    try {
      const response = await axios.post(
        `${baseurl}/api/Driver/v1.0/getTierList`,
        { driverId, adminId: AdminId },
        {
          headers: {
            Authorization: `Basic ${token}`,
          },
        },
      );

      if (response.data.responseCode === "00") {
        const data = response.data.data || [];
        toast.success(response.data.responseMessage || "Tiers loaded");
        setTiers(data);
        setFilteredTiers(data);
      } else if (response.data.responseCode === "401") {
        setIsUnauthorised(true);
      } else {
        toast.error(response.data.responseMessage || "Failed to fetch tiers");
      }
    } catch (error) {
      toast.error("Error fetching Tiers");
    } finally {
      setLoading(false);
    }
  };

  // ======= ALL TIER BENEFITS API =======
  const FetchAllTierBenefits = async (setTierBenefitsMap) => {
    setBenefitsLoading(true);
    try {
      const response = await axios.post(
        `${baseurl}/api/Driver/v1.0/getAllTierBenefitDetails`,
        { adminId: AdminId },
        {
          headers: {
            Authorization: `Basic ${token}`,
          },
        },
      );

      if (response.data.responseCode === "00") {
        const dataArray = response.data.data || [];
        const map = {};

        dataArray.forEach((entry) => {
          if (!entry?.tierId) return;
          map[String(entry.tierId)] = entry.benefits || [];
        });

        setTierBenefitsMap(map);
      } else if (response.data.responseCode === "401") {
        setIsUnauthorised(true);
      } else {
        toast.error(
          response.data.responseMessage ||
            "Failed to fetch tier benefits overview",
        );
      }
    } catch (error) {
      toast.error("Error fetching tier benefits overview");
    } finally {
      setBenefitsLoading(false);
    }
  };

  return {
    FetchTierCall,
    FetchAllTierBenefits,
    Loading,
    benefitsLoading,
  };
};

export default useTier;
